<template>
  <div>
    <b-row>
      <b-col sm="5">
        <b-row no-gutters>
          <b-col sm="5" style="padding-right: 1rem !important;">
            <b-form-group label="Card Type" label-for="typeList">
              <v-autocomplete
                v-on:change="cardTypeAutoMove"
                id="typeList"
                name="typeList"
                :items="typeList"
                :filter="autoCompleteStringFilter"
                autocomplete="typeList"
                return-object
                :value="value.cardType"
                @input="updateValue('cardType', $event)"
                :success="state('cardType')"
                :error-messages="errors.cardType"
                outlined
                dense
              ></v-autocomplete>
            </b-form-group>
          </b-col>

          <b-col sm="7">
            <b-form-group label="Card Number" label-for="cnumber">
              <b-form-input
                v-on:keyup="cardNumAutoMove"
                ref="cardNumber"
                autocomplete="off"
                inputmode="numeric"
                id="cnumber"
                :value="value.cnumber"
                @input="updateCnumberValue($event)"
                type="text"
                :state="state('cnumber')"
                aria-describedby="cnumber-error"
              />
              <b-form-invalid-feedback id="cnumber-error">
                {{ errors.cnumber }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col sm="3">
        <b-form-group label="Card Holder Name" label-for="name">
          <b-form-input
            ref="cardHolderName"
            autocomplete="off"
            id="name"
            :value="value.cardHolderName"
            @input="updateValue('cardHolderName', $event)"
            type="text"
            :state="state('cardHolderName')"
            aria-describedby="name-error"
          />
          <b-form-invalid-feedback id="name-error">
            {{ errors.cardHolderName }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group label="CVC" label-for="cvc">
          <b-form-input
            v-on:keyup="cvcAutoMove"
            ref="cvc"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]*"
            id="cvc"
            :value="value.cvc"
            @input="updateCvcValue($event)"
            style="width:100%;"
            type="password"
            :state="state('cvc')"
            aria-describedby="cvc-error"
          />
          <b-form-invalid-feedback id="cvc-error">
            {{ errors.cvc }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group label="Expiry(MM/YY)" label-for="expiry">
          <b-form-input
            ref="expiryDate"
            autocomplete="off"
            inputmode="numeric"
            id="expiry"
            :value="value.expiryDate"
            @input="updateExpiryDate($event)"
            @blur="expiryDateOnBlur($event)"
            type="text"
            :state="state('expiryDate')"
            aria-describedby="expiry-error"
          />
          <b-form-invalid-feedback id="expiry-error">
            {{ errors.expiryDate }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AutoNumeric from "autonumeric";
import { autoCompleteStringFilter } from "@/services/Formatting.js";

export default {
  data() {
    return {
      cvcMaxLength: 3
    };
  },
  props: {
    typeList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    cNumberLength: {
      type: Number,
      default: 16
    },
    value: {
      cnumber: {
        type: String,
        default: ""
      },
      cardHolderName: {
        type: String,
        default: ""
      },
      cvc: {
        type: Number,
        default: 0
      },
      expiryDate: {
        type: String,
        default: ""
      },
      cardType: {
        type: String,
        default: ""
      }
    },
    errorMessages: {
      type: Object,
      required: false,
      default() {
        return {
          cnumber: null,
          cardHolderName: null,
          cvc: null,
          expiryDate: null,
          cardType: null
        };
      }
    }
  },
  computed: {
    errors() {
      return {
        cnumber: this.getErrorMessage("cnumber"),
        cardHolderName: this.getErrorMessage("cardHolderName"),
        cvc: this.getErrorMessage("cvc"),
        expiryDate: this.getErrorMessage("expiryDate"),
        cardType: this.getErrorMessage("cardType")
      };
    }
  },
  methods: {
    autoCompleteStringFilter(item, searchText, itemText) {
      return autoCompleteStringFilter(item, searchText, itemText);
    },
    currentTrimFieldVal() {
      return event.currentTarget.value.replace(/[^0-9]+/g, "");
    },
    cardNumAutoMove() {
      if (this.currentTrimFieldVal().length == this.cNumberLength) {
        this.$refs.cardHolderName.focus();
      }
    },
    cardTypeAutoMove() {
      this.$refs.cardNumber.focus();
    },
    cvcAutoMove() {
      if (this.currentTrimFieldVal().length == this.cvcMaxLength) {
        this.$refs.expiryDate.focus();
      }
    },
    updateValue(key, value) {
      this.$emit("input", { ...this.value, [key]: value });
    },
    updateNumberValue(key, value) {
      let numValue = parseFloat(value);
      numValue = isNaN(numValue) ? "" : numValue;
      this.updateValue(key, numValue);
    },
    updateCnumberValue(value) {
      value = value.replace(/\D/g, "");
      const pattern = new RegExp(`\\d{4,${this.cNumberLength}}`, "g");
      var matches = value.match(pattern);
      var match = (matches && matches[0]) || "";
      var parts = [];
      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }
      if (parts.length) {
        value = parts.join(" ");
      }

      this.updateValue("cnumber", value);
    },
    updateCvcValue(value) {
      value = value.replace(/\D/g, "");
      if (value.length > this.cvcMaxLength) {
        value = value.substr(0, this.cvcMaxLength);
      }

      this.updateValue("cvc", value);
    },
    updateExpiryDate(value) {
      if (/\D\/$/.test(value)) {
        value = value.substr(0, value.length - 3);
      }
      var values = value.split("/").map(function(v) {
        return v.replace(/\D/g, "");
      });
      if (values[0]) values[0] = this.checkValue(values[0], 12);
      var output = values.map(function(v, i) {
        return v.length === 2 && i < 1 ? v + " / " : v;
      });
      value = output.join("").substr(0, 7);

      this.updateValue("expiryDate", value);
    },
    expiryDateOnBlur(event) {
      var value = event.srcElement.value;
      var values = value.split("/").map(function(v, i) {
        return v.replace(/\D/g, "");
      });
      var output = "";

      if (values.length === 2) {
        var year = values[1].substr(0, 3);
        var month = parseInt(values[0]) - 1;
        var d = new Date(year, month);
        if (!isNaN(d)) {
          var dates = [
            d.getMonth() + 1,
            d
              .getFullYear()
              .toString()
              .substr(2, 4)
          ];
          output = dates
            .map(function(v) {
              v = v.toString();
              return v.length === 1 ? "0" + v : v;
            })
            .join(" / ");
        }
      }
      value = output;
      this.updateValue("expiryDate", value);
    },
    checkValue(str, max) {
      if (str.charAt(0) !== "0" || str === "00") {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str =
          num > parseInt(max.toString().charAt(0)) &&
          num.toString().length === 1
            ? "0" + num
            : num.toString();
      }
      return str;
    },
    getErrorMessage(name) {
      return !!this.errorMessages ? this.errorMessages[name] : null;
    },
    state(name) {
      return this.errors[name] == null ? null : !this.errors[name].length;
    },
    ensureDomUpdateAfterFiltering() {
      var vm = this;
      document.getElementById("cnumber").addEventListener("input", function() {
        vm.$nextTick(() => (this.value = vm.value.cnumber));
      });

      document.getElementById("cvc").addEventListener("input", function() {
        vm.$nextTick(() => (this.value = vm.value.cvc));
      });

      document.getElementById("expiry").addEventListener("input", function(e) {
        vm.$nextTick(() => (this.value = vm.value.expiryDate));
      });
    }
  },
  mounted() {
    this.ensureDomUpdateAfterFiltering();
  }
};
</script>

<style lang="scss" scoped></style>
